/**
 * CarouselNavigation Component
 * 
 * This component renders navigation arrows for Swiper carousels.
 * It provides previous and next buttons to navigate through carousel items.
 * 
 * @author FarmCiti Team
 * @version 1.0.0
 */

import { ChevronLeft, ChevronRight } from "lucide-react";
import FarmCardStyle from "../../assets/stylesheets/FarmCard.module.css";
import logger from "../../utils/logger";

const log = logger.create("CarouselNavigation");

/**
 * CarouselNavigation component renders navigation arrows for Swiper carousels.
 * @param {Object} props
 * @param {Object} props.prevRef - Ref for the previous button
 * @param {Object} props.nextRef - Ref for the next button
 * @param {boolean} props.isBeginning - Whether the carousel is at the beginning
 * @param {boolean} props.isEnd - Whether the carousel is at the end
 * @returns {JSX.Element} Navigation arrows component
 */
function CarouselNavigation({ prevRef, nextRef, isBeginning, isEnd }) {
  return (
    <div className={FarmCardStyle["event-card-arrow"]}>
      <button
        ref={prevRef}
        className={`${FarmCardStyle["swiper-prev"]} ${
          isBeginning ? FarmCardStyle["swiper-disabled"] : ""
        }`}
        disabled={isBeginning}
      >
        <ChevronLeft className={FarmCardStyle["custom-arrow-icon"]} />
      </button>
      <button
        ref={nextRef}
        className={`${FarmCardStyle["swiper-next"]} ${
          isEnd ? FarmCardStyle["swiper-disabled"] : ""
        }`}
        disabled={isEnd}
      >
        <ChevronRight className={FarmCardStyle["custom-arrow-icon"]} />
      </button>
    </div>
  );
}

export default CarouselNavigation;
